// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d2dacd07","455":"ec99d07f","977":"34a6b1ab"}[chunkId] + ".chunk.js";
};